import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./CreateUser.css";
import { Button } from "@mui/material";
import { deleteClient } from "../services/clientService";
import { useNavigate } from 'react-router-dom';

const EditAccount = () => {
  const { id, type } = useParams();  // id might be a numeric ID (for user) OR slug (for client)
  const [initialData, setInitialData] = useState({});
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    name: '',
    description: '',
    logo: null,
    backgroundColor: '#ffffff',
    shareLink: '',
  });
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (type && id) {
      /* 
        OLD:
          const url = type === 'user'
            ? `/api/users.php?id=${id}`
            : `/api/clients.php?id=${id}`

        NEW: If 'client', fetch by slug=?slug={id}, 
        If 'user', keep the old approach with ?id={id}
      */
      const url = type === 'user'
        ? `${process.env.REACT_APP_BACKEND_URL}/api/users.php?id=${id}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/clients.php?slug=${id}`;

      axios.get(url)
        .then((response) => {
          const data = response.data;
          setInitialData(data);

          if (type === 'user') {
            setFormData({
              username: data.username || '',
              email: data.email || '',
              password: '',
            });
          } else {
            // "client"
            setFormData({
              name: data.name || '',
              description: data.description || '',
              logo: null,
              backgroundColor: data.background_color || '#ffffff',
              shareLink: data.share_link || '',
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching account details!", error);
        });
    }
  }, [id, type]);

  const handleDeleteClient = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this client?");
    if (!confirmDelete) return;
  
    try {
      const response = await deleteClient(id);
      // Optionally, refresh client list or navigate away
      alert("Client deleted successfully.");
      navigate('/admin/dashboard');

    } catch (error) {
      alert("Failed to delete client. Please try again.");
    }
  };
  
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === 'logo' && files.length > 0) {
      setFormData((prevState) => ({
        ...prevState,
        logo: files[0],  // Store file object
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const data = new FormData();
    data.append('type', type);
    
    if (type === 'client' && initialData.id) {
      data.append('id', initialData.id);
    } else {
      data.append('id', id);
    }
  
    if (type === 'client') {
      if (formData.name && formData.name !== initialData.name) {
        data.append('name', formData.name);
      }
      if (formData.description && formData.description !== initialData.description) {
        data.append('description', formData.description);
      }
      if (formData.backgroundColor && formData.backgroundColor !== initialData.background_color) {
        data.append('background_color', formData.backgroundColor);
      }
      if (formData.logo instanceof File) {
        data.append('logo', formData.logo);  // Only append if a new logo is selected
      }
      if (formData.shareLink && formData.shareLink !== initialData.share_link) {
        data.append('share_link', formData.shareLink);
      }
    }
  
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/edit-account.php`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => {
      setMessage("Account updated successfully!");
      setIsError(false);
      if (response.data.logo_path) {
        setInitialData((prevState) => ({
          ...prevState,
          logo: response.data.logo_path,  // Update the displayed logo
        }));
      }
    })
    .catch((error) => {
      setMessage("There was an error updating the account.");
      setIsError(true);
      console.error("Error updating account!", error);
    });
  };
  

  return (
    <div className="create-user">
      <div className="create-user-form">
        <div className="edit-account-form">
          <h2>Edit {type === 'user' ? 'User' : 'Client'} Account</h2>

          {message && (
            <div style={{ color: isError ? 'red' : 'green', marginBottom: '20px' }}>
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit} encType="multipart/form-data">
            {type === 'user' && (
              <>
                <label>
                  <p>Username:</p>
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                  />
                </label>
                <br />
                <label>
                  <p>Email:</p>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </label>
                <br />
                <label>
                  <p>Password:</p>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Leave blank to keep current password"
                  />
                </label>
                <br />
              </>
            )}

            {type === "client" && (
              <>
                <label>
                  <p>Name:</p>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </label>
                <br />
                <label>
                  <p>Description:</p>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </label>
                <br />

                {/* Show the current logo if one exists in the DB */}
                {initialData.logo && (
                  <div>
                    <p>Current Logo:</p>
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}/${initialData.logo}`}
                      alt="Current Logo"
                      style={{ width: '100px', height: 'auto' }}
                    />
                  </div>
                )}

                <label>
                  <p>New Logo (optional):</p>
                  <input
                    type="file"
                    name="logo"
                    onChange={handleChange}
                  />
                </label>
                <br />

                {/* --New Field for "share link" */}
                <label>
                  <p>Share Link (optional):</p>
                  <input
                    type="text"
                    name="shareLink"
                    value={formData.shareLink}
                    onChange={handleChange}
                  />
                </label>
                <br />

                <label>
                  <p>Background Color:</p>
                  <input
                    type="color"
                    name="backgroundColor"
                    className='background-color'
                    value={formData.backgroundColor}
                    onChange={handleChange}
                  />
                </label>
              </>
            )}

  <br />
  <br />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "80%",
              }}
            >
            <button type="submit">Update</button>
            {type === 'client' && (
              <button type="button" style={{backgroundColor: '#d32f2f'}} variant="contained" color="error" onClick={() => handleDeleteClient(initialData.id)}>
              Delete Client
            </button>
            )}
         </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditAccount;
